<template>
  <div v-if=" productsRelatedCount ">
    <div class="categorie_banner top_trending pr-0 pl-0 mt-5">
      <div class="row">
        <div class="col-12">
          <div class="categorie_banner_title">
            <h3>{{ $t('Productos relacionados con el Canal de Isabel II') }}</h3>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="categorie_active_two owl-carousel">
          <div v-for=" (item, index) in productsRelated " :key="index" class="col-lg-3">
            <router-link
              :to="{ name: 'type', params: { 
                language: getLocale,
                lin: setUrlParams(item.lin_id,item.lin_name),
                ctg: setUrlParams(item.ctg_id,item.ctg_name),
                sct: setUrlParams(item.sct_id,item.sct_name),
                typ: setUrlParams(item.typ_id,item.typ_name)
                } }" 
              class="c-products-related"
            >
              <div class="single_categorie_banner">
                <div class="categorie_banner_thumb">
                  <div 
                    :style=" 'background-image: url(\''+ getBaseUrl + getImgUrl + item.typ_image+'\''"
                    class="c-products-related-img" >
                  </div>
                  <div class="top_categorie_title">
                    <h3>
                      
                        {{ item.typ_name }}
                      
                    </h3>
                  </div>
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
      <!-- <div class="row">
        <div class="categorie_active_two owl-carousel">
          <div v-for=" (item, index) in productsRelated " :key="index" class="col-lg-3">
            <div class="single_categorie_banner">
              <div class="categorie_banner_thumb c-products-related">
                <div 
                  :style=" 'background-image: url(\''+ getBaseUrl + getImgUrl + item.typ_image+'\''"
                  class="c-products-related-img" >
                </div>
                <div class="top_categorie_title">
                  <h3>
                    <router-link
                      :to="{ name: 'type', params: { 
                        lin: setUrlParams(item.lin_id,item.lin_name),
                        ctg: setUrlParams(item.ctg_id,item.ctg_name),
                        sct: setUrlParams(item.sct_id,item.sct_name),
                        typ: setUrlParams(item.typ_id,item.typ_name)
                        } }" 
                    >
                      {{ item.typ_name }}
                    </router-link>
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<i18n>
  {
    "es": {
      "Productos relacionados con el Canal de Isabel II": "Productos relacionados con el Canal de Isabel II",
      "Error": "Error"
    },
    "en": {
      "Productos relacionados con el Canal de Isabel II": "Products related to the Canal de Isabel II",
      "Error": "Error"
    }
  }
</i18n>

<script>
  import { mapGetters } from 'vuex';

  import { mixinGlobal } from './../../mixins/mixinGlobal'

  export default {
    mixins: [ mixinGlobal ],
    data: () => {
      return {
        productsRelated: [],
        productsRelatedCount: 0
      }
    },
    mounted () {
      this.loadProductsRelated()
    },
    updated () {
      $('.categorie_active_two').owlCarousel({
        autoplay: true,
        loop: true,
        nav: true,
        autoplayTimeout: 8000,
        items: 10,
        dots:false,
        navText: ['<i class="fa fa-angle-left"></i>','<i class="fa fa-angle-right"></i>'],
        responsiveClass:true,
        responsive:{
          0:    { items: 1 },
          480:  { items: 3 },
          768:  { items: 4 },
          992:  { items: 5 },
          1200: { items: 5 }, 
          1600: { items: 5 },          
        }
      });
    },
    computed: {
      ...mapGetters(['getLocale', 'getBaseUrl', 'getApiUrl', 'getImgUrl']),
    },
    methods: {
      loadProductsRelated(){
        this.$axios.get(this.getApiUrl + 'relacionados.php')
        .then( (respuesta) =>{ 
          this.productsRelated = respuesta.data.data
          this.productsRelatedCount = respuesta.data.res_num
        })
        .catch( (error) =>{ 
          let  message = '';
          if (error.response.hasOwnProperty('data')){
            if (error.response.data.hasOwnProperty('message')) {
              message = error.response.data.message;
            }else{
              message = error
            }
          }else{
            message = error            
          }
          this.$store.commit('mutateGlobalMessage', { toast: true, icon: 'error', title: this.$t('Error'), message:   message } )
          this.favlistModalLoading = false
        }) 
      }
    },

  }

</script>
